<script>
	import { Bar } from 'vue-chartjs';
	import { chunk } from 'lodash';

	export default {
		extends: Bar,
		props: ['data', 'totalPropostas'],
		inject: ['vigencia', 'mapVigencia'],
		mounted() {
			this.renderChart(
				{
					labels: chunk(
						this.vigencia.map((item) => item.xDate),
						6
					)[1],
					datasets: [
						{
							label: 'Novos',
							backgroundColor: 'rgba(2, 166, 242, 1)',
							// borderColor: 'rgba(2, 166, 242, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.novos,
									'vigencia',
									'qnt'
								),
								6
							)[1],
						},
						{
							label: 'Ativos',
							backgroundColor: 'rgba(139, 195, 74, 1)',
							// borderColor: 'rgba(139, 195, 74, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.ativos,
									'mounthContract',
									'total'
								),
								6
							)[1],
						},
						{
							label: 'Suspensos',
							backgroundColor: 'rgba(255, 152, 0, 1)',
							// borderColor: 'rgba(255, 152, 0, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.suspensos,
									'mounthContract',
									'total'
								),
								6
							)[1],
						},
						{
							label: 'Cancelados',
							backgroundColor: 'rgba(244, 67, 54, 1)',
							// borderColor: 'rgba(244, 67, 54, 1)',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.data.cancelados,
									'mounthContract',
									'total'
								),
								6
							)[1],
						},

						{
							label: 'Propostas',
							backgroundColor: 'rgba(0, 0, 0, 0)',
							borderColor: '#01416f',
							data: chunk(
								this.mapVigencia(
									this.vigencia,
									this.totalPropostas,
									'event',
									'total'
								),
								6
							)[1],
							type: 'line',
						},
					],
				},
				{
					responsive: true,
					maintainAspectRatio: false,
				}
			);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/components/contatos.vue